<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.5303 5.21982C13.8232 5.51271 13.8232 5.98759 13.5303 6.28048L9.6617 10.1491C9.6555 10.1553 9.64932 10.1615 9.64316 10.1677C9.4611 10.3497 9.2939 10.517 9.14269 10.6453C8.97967 10.7837 8.78661 10.9204 8.54078 11.0003C8.1893 11.1145 7.8107 11.1145 7.45922 11.0003C7.21339 10.9204 7.02033 10.7837 6.85731 10.6453C6.7061 10.517 6.53889 10.3497 6.35684 10.1677L6.3383 10.1491L2.46967 6.28048C2.17678 5.98759 2.17678 5.51271 2.46967 5.21982C2.76256 4.92693 3.23744 4.92693 3.53033 5.21982L7.39896 9.08845C7.60572 9.29521 7.72931 9.41797 7.82807 9.50182C7.88835 9.55299 7.91778 9.57041 7.92601 9.57474C7.97421 9.58967 8.0258 9.58967 8.07399 9.57474C8.08222 9.57041 8.11165 9.55299 8.17193 9.50182C8.27069 9.41797 8.39428 9.29521 8.60104 9.08845L12.4697 5.21982C12.7626 4.92693 13.2374 4.92693 13.5303 5.21982Z"
    fill="currentColor"
  />
</svg>
